import { timer, EMPTY, of } from "rxjs";
import {
  reduce,
  tap,
  delayWhen,
  /////////////////
  buffer,
  bufferCount,
  bufferTime,
  bufferToggle,
  bufferWhen,
  concatMap,
  exhaustMap,
  expand,
  groupBy,
  map,
  mergeMap,
  mergeScan,
  pairwise,
  partition,
  repeat,
  scan,
  startWith,
  switchMap,
  switchScan,
  window,
  windowCount,
  windowTime,
  windowToggle,
  windowWhen,
  withLatestFrom
} from "rxjs/operators";

export const transformationExamples = {
  buffer: {
    label: "buffer",
    inputs: [
      [
        { t: 9, c: "A" },
        { t: 23, c: "B" },
        { t: 40, c: "C" },
        { t: 54, c: "D" },
        { t: 60, c: "E" },
        { t: 85, c: "F" }
      ],
      [
        { t: 33, c: 0 },
        { t: 66, c: 0 },
        { t: 90, c: 0 }
      ]
    ],
    apply: function (inputs) {
      return inputs[0].pipe(
        map((i) => i.content),
        buffer(inputs[1]),
        map((x) => `[${x}]`)
      );
    }
  },

  bufferCount: {
    label: "bufferCount(3, 2)",
    inputs: [
      [
        { t: 9, c: "A" },
        { t: 23, c: "B" },
        { t: 40, c: "C" },
        { t: 54, c: "D" },
        { t: 71, c: "E" },
        { t: 85, c: "F" },
        90
      ]
    ],
    apply: function (inputs) {
      return inputs[0].pipe(
        map((i) => i.content),
        bufferCount(3, 2),
        map((arr) => `[${arr}]`),
        tap(console.log)
      );
    }
  },

  bufferTime: {
    label: "bufferTime(30)",
    inputs: [
      [
        { t: 0, c: "A" },
        { t: 10, c: "B" },
        { t: 22, c: "C" },
        { t: 61, c: "D" },
        { t: 71, c: "E" },
        { t: 95, c: "F" }
      ]
    ],
    apply: function (inputs, scheduler) {
      return inputs[0].pipe(
        map((i) => i.content),
        bufferTime(30, scheduler),
        map((x) => `[${x}]`)
      );
    }
  },

  bufferToggle: {
    label: "bufferToggle(open$, x => timer(x))",
    inputs: [
      [
        { t: 0, c: 1 },
        { t: 10, c: 2 },
        { t: 20, c: 3 },
        { t: 30, c: 4 },
        { t: 40, c: 5 },
        { t: 50, c: 6 },
        { t: 60, c: 7 },
        { t: 70, c: 8 },
        { t: 80, c: 9 }
      ],
      [
        { t: 15, c: 10 },
        { t: 45, c: 30 }
      ]
    ],
    apply: function (inputs, scheduler) {
      return inputs[0].pipe(
        map((i) => i.content),
        bufferToggle(inputs[1], (x) => timer(x.content, scheduler)),
        map((x) => `[${x}]`)
      );
    }
  },

  bufferWhen: {
    label: "bufferWhen",
    inputs: [
      [
        { t: 0, c: 1 },
        { t: 10, c: 2 },
        { t: 20, c: 3 },
        { t: 30, c: 4 },
        { t: 40, c: 5 },
        { t: 50, c: 6 },
        { t: 60, c: 7 },
        { t: 70, c: 8 },
        { t: 80, c: 9 }
      ],
      [
        { t: 35, c: 0 },
        { t: 50, c: 0 }
      ]
    ],
    apply: function (inputs) {
      return inputs[0].pipe(
        map((i) => i.content),
        bufferWhen(() => inputs[1]),
        map((x) => `[${x}]`)
      );
    }
  },

  concatMap: {
    label: "concatMap",
    inputs: [
      [
        { t: 0, c: "A" },
        { t: 42, c: "B" },
        { t: 55, c: "C" }
      ],
      [{ t: 0, c: 1 }, { t: 10, c: 2 }, { t: 20, c: 3 }, 20]
    ],
    apply: function (inputs, scheduler) {
      return inputs[0].pipe(
        concatMap((x) => inputs[1].pipe(map((y) => "" + x.content + y.content)))
      );
    }
  },

  exhaustMap: {
    label: "exhaustMap",
    inputs: [
      [
        { t: 0, c: "A" },
        { t: 42, c: "B" },
        { t: 55, c: "C" }
      ],
      [{ t: 0, c: 1 }, { t: 10, c: 2 }, { t: 20, c: 3 }, 20]
    ],
    apply: function (inputs, scheduler) {
      return inputs[0].pipe(
        exhaustMap((x) =>
          inputs[1].pipe(map((y) => "" + x.content + y.content))
        )
      );
    }
  },

  // // It's similar to mergeMap, but applies the projection function to every source value as well as every output value. It's recursive.
  // expand: {
  //   label: "expand:recursive",
  //   inputs: [
  //     [{ t: 0, c: 2 }, 30],
  //     [{ t: 0, c: 3 }, 10]
  //   ],
  //   apply: function (inputs, scheduler) {
  //     return inputs[0].pipe(
  //       expand((x) =>
  //         x >= 18 ? EMPTY : inputs[1].pipe(map((y) => x.content * y.content))
  //       )
  //     );
  //   }
  // },

  groupBy: {
    label: "groupBy(i => i.content)【结果3,4重合】",
    inputs: [
      [
        { t: 10, c: 1 },
        { t: 20, c: 2 },
        { t: 30, c: 1 },
        { t: 40, c: 2 },
        { t: 50, c: 1 },
        60
      ]
    ],
    apply: function (inputs, scheduler) {
      return inputs[0].pipe(
        groupBy((i) => i.content),
        mergeMap((group$) =>
          group$.pipe(reduce((acc, cur) => acc + cur.content, 0))
        ),
        tap(console.log)
      );
    }
  },

  map: {
    label: "map(x => 10 * x)",
    inputs: [
      [
        { t: 10, c: 1 },
        { t: 20, c: 2 },
        { t: 50, c: 3 }
      ]
    ],
    apply: function (inputs) {
      return inputs[0].pipe(map((i) => i.content * 10));
    }
  },

  mergeMap: {
    label: "mergeMap",
    inputs: [
      [
        { t: 0, c: "A" },
        { t: 42, c: "B" },
        { t: 55, c: "C" }
      ],
      [{ t: 0, c: 1 }, { t: 10, c: 2 }, { t: 20, c: 3 }, 20]
    ],
    apply: function (inputs, scheduler) {
      return inputs[0].pipe(
        mergeMap((x) => inputs[1].pipe(map((y) => "" + x.content + y.content)))
      );
    }
  },

  // It's like scan, but the Observables returned by the accumulator are merged into the outer Observable.
  mergeScan: {
    label: "mergeScan",
    inputs: [
      [
        { t: 5, c: 1 },
        { t: 15, c: 2 },
        { t: 25, c: 3 },
        { t: 35, c: 4 },
        { t: 65, c: 5 },
        70
      ]
    ],
    apply: function (inputs) {
      return inputs[0].pipe(mergeScan((acc, x) => of(acc + x.content), 0));
    }
  },

  pairwise: {
    label: "pairwise",
    inputs: [
      [
        { t: 9, c: "A" },
        { t: 23, c: "B" },
        { t: 40, c: "C" },
        { t: 54, c: "D" },
        { t: 71, c: "E" },
        { t: 85, c: "F" }
      ]
    ],
    apply: function (inputs) {
      return inputs[0].pipe(
        map((x) => x.content),
        pairwise(),
        map((x) => `[${x}]`)
      );
    }
  },

  // partition
  // const observableValues = of(1, 2, 3, 4, 5, 6);
  // const [evens$, odds$] = partition(observableValues, value => value % 2 === 0);

  repeat: {
    label: "repeat(3)",
    inputs: [[{ t: 0, c: "A" }, { t: 12, c: "B" }, 26]],
    apply: function (inputs) {
      return inputs[0].pipe(repeat(3));
    }
  },

  scan: {
    label: "scan",
    inputs: [
      [
        { t: 5, c: 1 },
        { t: 15, c: 2 },
        { t: 25, c: 3 },
        { t: 35, c: 4 },
        { t: 65, c: 5 }
      ]
    ],
    apply: function (inputs) {
      return inputs[0].pipe(scan((acc, x) => acc + x.content, 0));
    }
  },

  startWith: {
    label: "startWith(1)",
    inputs: [
      [
        { t: 30, c: 2 },
        { t: 40, c: 3 }
      ]
    ],
    apply: function (inputs, scheduler) {
      return inputs[0].pipe(startWith(1, scheduler));
    }
  },

  switchMap: {
    label: "switchMap",
    inputs: [
      [
        { t: 0, c: "A" },
        { t: 42, c: "B" },
        { t: 55, c: "C" }
      ],
      [{ t: 0, c: 1 }, { t: 10, c: 2 }, { t: 20, c: 3 }, 25]
    ],
    apply: function (inputs, scheduler) {
      return inputs[0].pipe(
        map((x) => x.content),
        switchMap(
          () => inputs[1].pipe(map((x) => x.content)),
          (x, y) => "" + x + y
        )
      );
    }
  },

  // It's like mergeScan, but only the most recent Observable returned by the accumulator is merged into the outer Observable.
  switchScan: {
    label: "switchScan",
    inputs: [
      [
        { t: 5, c: 1 },
        { t: 15, c: 2 },
        { t: 25, c: 3 },
        { t: 35, c: 4 },
        { t: 65, c: 5 },
        70
      ]
    ],
    apply: function (inputs) {
      return inputs[0].pipe(switchScan((acc, x) => of(acc + x.content), 0));
    }
  },

  withLatestFrom: {
    label: 'withLatestFrom(input, (x, y) => "" + x + y)',
    inputs: [
      [
        { t: 0, c: 1 },
        { t: 20, c: 2 },
        { t: 65, c: 3 },
        { t: 75, c: 4 },
        { t: 92, c: 5 }
      ],
      [
        { t: 10, c: "A" },
        { t: 25, c: "B" },
        { t: 50, c: "C" },
        { t: 57, c: "D" }
      ]
    ],
    apply: function (inputs) {
      return inputs[0].pipe(
        withLatestFrom(inputs[1], (x, y) => "" + x.content + y.content)
      );
    }
  }
};
